import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "../Loadable";

const BinaryTree = Loadable(
  lazy(() => import("src/pages/userSide/genealogy/binary/index"))
);

const BinaryLeg = Loadable(
  lazy(() => import("src/pages/userSide/genealogy/binaryLeg/index"))
);
const Sponsor = Loadable(
  lazy(() => import("src/pages/genealogy/sponsor/index"))
);

const Affiliate = Loadable(
  lazy(() => import("src/pages/userSide/genealogy/affiliate/index"))
);

const genealogy = {
  path: "genealogy",
  children: [
    { index: true, element: <Navigate to="binary" /> },
    { path: "binaryLeg", element: <BinaryLeg /> },
    { path: "binary", element: <BinaryTree /> },
    { path: "sponsor", element: <Sponsor url="api/user/sponsortree" /> },
    { path: "affiliate", element: <Affiliate /> },
  ],
};

export default genealogy;
